<template>
  <div class="wrap">
    <mt-header title="设置昵称">
      <router-link to="/more/showinfo" slot="left">
        <span class="quxiao">取消</span>
      </router-link>
      <mt-button slot="right" v-bind:class="{'selected': isA, 'selected-t': opacity}" @click="finish()">
        <span ref="finish" disabled="disabled">完成</span>
      </mt-button>
    </mt-header>
    <div class="usernameShow">
      <input type="text" class="input" v-on:focus="lightingColor()" v-model="username" ref="txt">
      <i class="iconfont icon-guanbi1 icon" @click="Null" v-show="isOpen"></i>
    </div>
  </div>
</template>
<script>
  import apis from '../../apis/index'
  import cloudApi from '../../apis/cloudStorageApi'
  import { Toast } from 'mint-ui'

  export default {
    data () {
      return {
        username: JSON.parse(localStorage.mobileData).nickName,
        isA: true,
        opacity: false,
        isOpen: true
      }
    },
    components: {
      Toast
    },
    methods: {
      Null () {
        this.username = ''
        this.isOpen = false
      },
      lightingColor () {
        this.isA = false
        this.opacity = true
        this.isOpen = true
      },
      finish () {
        var _this = this
        var txt = _this.$refs.txt.value
        if (txt === JSON.parse(localStorage.mobileData).nickName) {
          return false
        }
        apis.request(cloudApi.info, {value: txt, type: 2}).then(function () {
          Toast({
            message: '修改成功',
            iconClass: 'icon-success'
          })
          var mobileData = window.localStorage.getItem('mobileData')
          mobileData = JSON.parse(mobileData)
          mobileData.nickName = txt
          mobileData = JSON.stringify(mobileData)
          window.localStorage.setItem('mobileData', mobileData)
          _this.$router.push({path: '/more/showinfo'})
        }).catch(function (error) {
          Toast({
            message: error.response.data.message,
            iconClass: 'icon-error'
          })
        })
      }
    }
  }
</script>
<style scoped>
  .mint-header {
    position: fixed;
    top: 0;
    height: 1.28rem;
    width: 100%;
    background-color: #E4393C;
  }

  .quxiao {
    font-size: .28rem;
  }

  .wrap {
    padding-top: 1.28rem;
    height: 100%;
  }

  .mint-header-title {
    font-size: .36rem;
    font-weight: 500;
  }

  .mint-button-text {
    font-size: .28rem;
  }

  .selected {
    color: #fff !important;
    font-size: 0.3rem;
    opacity: 0.3;
    background: inherit !important;
  }

  .selected-t {
    opacity: 1;
    font-size: 0.3rem;
  }

  .usernameShow {
    margin-top: .2rem;
    position: relative;
  }

  .input {
    height: .9rem;
    line-height: .9rem;
    width: 100%;
    font-size: .28rem;
    text-align: left;
    padding-left: .3rem;
    color: #1d1f22;
  }

  .icon {
    position: absolute;
    right: 5%;
    top: 36%;
    width: .3rem;
    height: .3rem;
    color: #a0a1a7;
  }

  .icon-success {
    background: url("../../assets/images/success_icon.png") center no-repeat;
    background-size: 0.98rem 0.7rem;
    margin: 0 auto;
    width: 0.98rem;
    height: 0.7rem;
  }

  .icon-error {
    background: url("../../assets/images/x.png") center no-repeat;
    margin: 0 auto;
    width: 0.98rem;
    height: 0.7rem;
  }
</style>
<style>
  .mint-header-title {
    font-size: .36rem;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/views/more/changusername.vue